class Select
    constructor: (el) ->
        @.$el = el
        if !@.$el.classList.contains 'select--bound'
            @.$errorEl = @.$el.querySelector '.select__error'
            @.$select = undefined
            @.$selectSpacer = undefined
            @.$selectChoosenText = undefined
            @.$selectInput = @.$el.querySelector 'select'
            @.$selectMenu = undefined

            @.disabled = @.$selectInput.disabled
            @.error = @.$el.classList.contains 'select--error'
            @.id = @.$el.id ? null
            @.maxHeight = @.$el.dataset?.maxHeight ? false
            @.menuOver = @.$el.classList.contains 'select--menu-over'
            @.multiple = @.$selectInput.multiple
            @.multipleAllText = if @.multiple then (@.$el.data?.allText ? 'Alle') else undefined
            @.multipleNoneText = if @.multiple then (@.$el.data?.noneText ? 'Keine') else undefined
            @.multipleSelectionText = if @.multiple then (@.$el.data?.selectionText ? 'Auswahl') else undefined
            @.open = @.$el.classList.contains 'select--open'
            @.options = []
            @.placeholder = @.$el.querySelector('.select--placeholder')?.innerHTML ? @.$el.data?.placeholder ? 'Bitte wählen'
            @.reset = false
            @.resetInterval = undefined
            @.resetDelay = 100
            @.required = @.$el.classList.contains 'select--required'
            @.requiredText = @.$el.dataset?.requiredText ? false

            @.$el.classList.add 'select--bound'
            @.CheckId()
            @.BuildElement()
        return

    BuildElement: ->
        @.$select = document.createElement 'div'
        @.$select.classList.add 'select__box', 'icon-chevron-after'
        @.$select.innerHTML = "
            <div class='select__box__text'>#{@.placeholder}#{if @.multiple then '<span class="select__box__text__choosen"></span>' else ''}</div>
            <ul class='select__box__menu'>
            </ul>
        "
        if @.menuOver
            @.$selectSpacer = document.createElement 'div'
            @.$selectSpacer.classList.add 'select__box-spacer'
        if @.multiple
            @.$select.classList.add 'select__box--multiple'
            @.$selectChoosenText = @.$select.querySelector '.select__box__text__choosen'

        @.$selectMenu = @.$select.querySelector '.select__box__menu'

        optionsCount = 0
        for child in @.$selectInput.children
            if child.tagName == "OPTGROUP"
                option = {
                    optGroup: {
                        label: child.label
                        options: []
                    }
                }
                menuList = document.createElement 'ul'
                menuList.classList.add 'select__optgroup'
                menuList.innerHTML = "<span>#{ child.label }</span>"
                for optGroupChild in child.children
                    if optGroupChild.tagName == "OPTION"
                        optionsOption = OptionNodeToObject optGroupChild, optionsCount
                        if optionsOption != null
                            optionsCount++
                            option.optGroup.options.push optionsOption
                            optGroupChild.dataset.count = optionsCount
                            menuList.appendChild OptionToMenuItem optionsOption, @, optionsCount
                @.options.push option
                @.$selectMenu.appendChild menuList
            else
                option = OptionNodeToObject child, optionsCount
                if option != null
                    optionsCount++
                    @.options.push option
                    child.dataset.count = optionsCount
                    @.$selectMenu.appendChild OptionToMenuItem option, @, optionsCount
        if optionsCount == 0
            @.$selectInput.disabled = true
            @.disabled = true
        @.$el.insertBefore @.$select, @.$el.querySelector('.select__error')
        if @.menuOver
            @.$el.insertBefore @.$selectSpacer, @.$el.querySelector('.select__error')
        @.SetBoxText()
        @.InitEvents()
        return
    
    CheckId: ->
        if (@.id && document.querySelectorAll('#' + @.id).length > 1) || @.id == null || @.id == ""
            @.id = window.appUtils.GenerateId 'select_', 5
            @.$el.id = @.id
        return
    
    CloseSelect: ->
        @.$el.classList.remove 'select--open'
        @.open = false
        if @.maxHeight
            @.$selectMenu.style.removeProperty 'max-height'
            @.$selectMenu.style.removeProperty 'overflow-y'
        return
    
    HandleOptionClick: (optionEl) ->
        if optionEl.classList.contains 'select__option--selected'
            @.$selectInput.querySelector("option[data-count='#{ optionEl.dataset.count }']").selected = false
        else
            @.$selectInput.querySelector("option[data-count='#{ optionEl.dataset.count }']").selected = true
        @.$selectInput.dispatchEvent new Event 'change', { bubbles: false }
        return
    
    InitEvents: ->
        self = @
        @.$el.addEventListener 'select-reset', (e) ->
            self.Reset()
            return
        @.$el.addEventListener 'select-set-error', (e) ->
            showError = e.detail?.showError ? false
            errorText = e.detail?.errorText ? self.requiredText
            if showError
                self.SetError errorText
            else
                self.SetError false
            return
        @.$selectInput.addEventListener 'change', (e) ->
            if @.value != "" && @.value != "---placeholder---"
                self.SetError false
            else
                if self.required
                    self.SetError self.requiredText
            return
        @.$select.querySelector '.select__box__text'
            .addEventListener 'click', (e) ->
                if self.$el.classList.contains 'select--open'
                    self.CloseSelect()
                else
                    self.OpenSelect()
                return
        @.$select.querySelectorAll '.select__option'
            .forEach (optionEl) ->
                optionEl.addEventListener 'click', (e) ->
                    if !optionEl.classList.contains 'select__option--disabled'
                        if !self.multiple
                            self.$select.querySelectorAll '.select__option'
                                .forEach (el) ->
                                    el.classList.remove 'select__option--selected'
                                    return
                            self.$selectInput.querySelectorAll 'option'
                                .forEach (selectOptionEl) ->
                                    selectOptionEl.selected = false
                            self.CloseSelect()

                        self.HandleOptionClick optionEl
                        optionEl.classList.toggle 'select__option--selected'
                        self.SetBoxText()
                    return
                return
        @.$el.addEventListener 'select-open', (e) ->
            self.OpenSelect()
            return
        @.$el.addEventListener 'select-close', (e) ->
            self.CloseSelect()
            return
        @.$el.addEventListener 'select-reset', (e) ->
            self.ResetSelect()
            return
        return
    
    OpenSelect: ->
        @.$el.classList.add 'select--open'
        @.open = true
        if @.maxHeight
            @.$selectMenu.style.maxHeight = @.maxHeight
            @.$selectMenu.style.overflowY = "auto"
        return
    
    Reset: ->
        optionItems = @.$select.querySelectorAll '.select__option'
        for optionItem in optionItems
            optionItem.classList.remove 'select__option--selected'
        @.$selectInput.value = ""
        @.$selectInput.querySelectorAll 'option'
            .forEach (selectOption) ->
                if selectOption.classList?.contains 'select--placeholder'
                    selectOption.setAttribute "selected", ""
                else
                    selectOption.removeAttribute "selected"
                return
        @.$select.querySelector '.select__box__text'
            .innerHTML = @.placeholder
        @.SetError false
        return
    
    SetBoxText: ->
        if !@.reset
            if @.multiple
                optionItems = @.$select.querySelectorAll '.select__option:not(.select__option--disabled)'
                selectedCount = 0
                for optionItem in optionItems
                    if optionItem.classList.contains('select__option--selected')
                        selectedCount++
                if selectedCount == 0
                    @.$selectChoosenText.innerHTML = @.multipleNoneText
                else
                    if selectedCount == optionItems.length
                        @.$selectChoosenText.innerHTML = @.multipleAllText
                    else
                        @.$selectChoosenText.innerHTML = @.multipleSelectionText
            else
                selectedItem = @.$select.querySelector('.select__option--selected')
                if selectedItem
                    @.$select.querySelector '.select__box__text'
                        .innerHTML = selectedItem.innerHTML
            if @.menuOver
                @.$selectSpacer.style.width = "#{ @.$select.offsetWidth }px"
        else
            @.reset = false
        return
    
    SetBoxTextManually: (boxText) ->
        if boxText && boxText != ""
            if @.multiple
                @.$selectChoosenText.innerHTML = boxText
            else
                @.$select.querySelector '.select__box__text'
                    .innerHTML = boxText
            if @.menuOver
                @.$selectSpacer.style.width = "#{ @.$select.offsetWidth }px"
        return
    
    SetError: (error) ->
        if error
            @.$errorEl.innerHTML = error
            @.$el.classList.add 'select--error'
            @.error = true
        else
            @.$errorEl.innerHTML = ""
            @.$el.classList.remove 'select--error'
            @.error = false
        return

    OptionNodeToObject = (optionNode, actualOptionsCount) ->
        if optionNode.tagName == "OPTION"
            if !optionNode.classList.contains 'select--placeholder'
                return {
                    count: actualOptionsCount + 1
                    disabled: optionNode.disabled
                    selected: optionNode.selected
                    text: optionNode.innerHTML
                    value: optionNode.value
                }
        return null
    
    OptionToMenuItem = (option, self, optionsCount) ->
        menuItem = document.createElement 'li'
        menuItem.classList.add 'select__option'
        menuItem.dataset.count = optionsCount
        if option.disabled
            menuItem.classList.add 'select__option--disabled'
        if option.selected
            menuItem.classList.add 'select__option--selected'
        menuItem.innerHTML = "#{ option.text }"
        if self.multiple
            unmarkButton = document.createElement 'button'
            unmarkButton.type = "button"
            unmarkButton.classList.add 'select__option__unmark', 'icon-close-delete-after'
            menuItem.appendChild unmarkButton
        return menuItem
    
    ResetSelect: ->
        self = @
        @.$selectInput.selectedIndex = 0
        @.reset = true
        @.SetBoxTextManually @.placeholder
        window.clearInterval @.resetInterval
        @.resetInterval = window.setInterval ->
            window.clearInterval self.resetInterval
            self.$el.querySelectorAll '.select__option--selected'
                .forEach (selectedOptionEl) ->
                    selectedOptionEl.classList.remove 'select__option--selected'
                    return
            return
        , @.resetDelay
        return


BindSelects = ->
    document.querySelectorAll '.select:not(.select--bound)'
        .forEach (el) ->
            new Select el
            return
    return

CloseSelectsBinder = ->
    if document.querySelectorAll('.select--bound').length > 0
        window.addEventListener 'click', (e) ->
            if !e.target.classList.contains('select__box') && !e.target.closest('.select__box')
                document.querySelectorAll '.select'
                    .forEach (selectEl) ->
                        if !selectEl.classList.contains 'select--keep-open'
                            selectEl.dispatchEvent new CustomEvent 'select-close', { bubbles: false }
                        return
            return
    return

SelectsBindComponents = ->
    BindSelects()
    CloseSelectsBinder()
    return

window.addEventListener 'bind-components', SelectsBindComponents

class SelectCreate
    constructor: (options) ->
        @.$el = null

        @.attrs = options?.attrs ? false
        @.autofocus = options?.autofocus ? false
        @.bindLater = options?.bindLater ? false
        @.disabled = options?.disabled ? false
        @.error = options?.error ? false
        @.form = options?.form ? false
        @.id = options?.id ? false
        @.keepOpen = options?.keepOpen ? false
        @.maxHeight = options?.maxHeight ? false
        @.menuOver = options?.menuOver ? false
        @.multiple = options?.multiple ? false
        @.multipleAllText = options?.multipleAllText ? false
        @.multipleNoneText = options?.multipleNoneText ? false
        @.multipleSelectionText = options?.multipleSelectionText ? false
        @.name = options?.name ? false
        @.noOutline = options?.noOutline ? false
        @.open = options?.open ? false
        @.options = options?.options ? []
        @.placeholder = options?.placeholder ? "Bitte wählen"
        @.required = options?.required ? false
        @.requiredText = options?.requiredText ? "Mindestens eine Option muss gewählt werden"
        @.selectedOption = options?.selected ? ""
        @.size = options?.size ? false
        @.tag = options?.tag ? 'div'

        @.CreateElement()
        if !@.bindLater
            new Select @.$el
        return @.$el

    CreateElement: ->
        @.$el = document.createElement @.tag
        if @.attrs
            @.$el = window.appUtils.Attributes @.attrs, @.$el
        @.$el.classList.add 'select'
        if @.id
            @.$el.id = @.id
        if @.keepOpen
            @.$el.classList.add 'select--keep-open'
        if @.menuOver
            @.$el.classList.add 'select--menu-over'
        if @.noOutline
            @.$el.classList.add 'select--no-outline'
        if @.open
            @.$el.classList.add 'select--open'
        @.$el.dataset.placeholder = @.placeholder
        if @.maxHeight
            @.$el.dataset.maxHeight = @.maxHeight
        if @.multiple
            if @.multipleAllText
                @.$el.dataset.allText = @.multipleAllText
            if @.multipleNoneText
                @.$el.dataset.noneText = @.multipleNoneText
            if @.multipleSelectionText
                @.$el.dataset.selectionText = @.multipleSelectionText
        @.$el.innerHTML = "
            <select#{ if @.id then "id='#{ @.id }__select'" else "" }#{ if @.required then " required" else "" }#{ if @.name then " name='#{ @.name }'" else "" }>
            </select>
            <span class='select__error'>#{ error ? "" }</span>
        "
        selectEl = @.$el.querySelector 'select'
        if @.autofocus
            selectEl.setAttribute 'autofocus', ''
        if @.disabled
            @.$el.classList.add 'select--disabled'
            selectEl.disabled = true
        if @.error
            @.$el.classList.add 'select--error'
        if @.form
            selectEl.setAttribute 'form', @.form
        if @.multiple
            selectEl.setAttribute 'multiple', ''
        if @.name
            selectEl.setAttribute 'name', @.name
        if @.required
            selectEl.required = true
            if @.requiredText
                @.$el.dataset.requiredText = @.requiredText
        if @.size
            selectEl.setAttribute 'size', @.size
        if @.placeholder
            selectEl.innerHTML = "
                <option class='select--placeholder' disabled selected value='---placeholder---'>#{ @.placeholder }</option>
            "
        @.options.forEach (option) ->
            if option.optGroup
                label = option.optGroup.label ? 'Gruppe'
                optGroupEl = document.createElement 'optgroup'
                optGroupEl.label = label
                optGroupOptions = option.optGroup.options ? []
                optGroupOptions.forEach (optGroupOption) ->
                    optGroupOptionEl = document.createElement 'option'
                    if optGroupOption.disabled
                        optGroupOptionEl.disabled = true
                    if optGroupOption.selected
                        optGroupOptionEl.selected = true
                    if typeof optGroupOption.value != "undefined"
                        optGroupOptionEl.value = optGroupOption.value
                    optGroupOptionEl.innerHTML = "
                        #{ optGroupOption.text ? "Option" }
                    "
                    optGroupEl.appendChild optGroupOptionEl
                    return
                selectEl.appendChild optGroupEl
            else
                optionEl = document.createElement 'option'
                if option.disabled
                    optionEl.disabled = true
                if option.selected
                    optionEl.selected = true
                if typeof option.value != "undefined"
                    optionEl.value = option.value
                optionEl.innerHTML = "
                    #{ option.text ? "Option" }
                "
                selectEl.appendChild optionEl
            return
        return

window.CreateSelect = (options) ->
    return new SelectCreate options